import React from 'react';
import { DiscardConfirmation } from '../../libs/gs-component-right-rail';

interface Props {
  onContinue: () => void;
  onCancel: () => void;
  canceling: boolean;
}

const Confirmable: React.FC<Props> = ({ canceling, onContinue, onCancel, children }) => {
  return canceling ? <DiscardConfirmation onContinue={onContinue} onCancel={onCancel} /> : <>{children}</>;
};

export default Confirmable;
